import { render } from "./ContentWrapperControl.vue?vue&type=template&id=ab0d27ce"
import script from "./ContentWrapperControl.vue?vue&type=script&lang=js"
export * from "./ContentWrapperControl.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__